import { useMemo } from "react";
import { Box } from "@mui/material";
import DataTable from "../../../../components/common/datatable/DataTable";
import HeaderWithInfo from "../../../../components/common/datatable/HeaderWithInfo";
import { compareDateValues } from "../../../../utils/dateUtils";

const COLUMN_INFO = {
  totalSupplierForecastOriginal: "Original supplier forecast published for the week.",
  totalSupplierForecastCurrent: "Current SAP forecast for the week.",
  totalSupplierConfirmation: "Total supplier confirmation for the week.",
};

const formatSupplierConfirmation = (value) =>
  value === null ||
  value === undefined ||
  value === "-" ||
  value === "—" ||
  value === "" ||
  Number.isNaN(value)
    ? "N/A"
    : value;

const formatDisplayValue = (value) =>
  value === null ||
  value === undefined ||
  value === "" ||
  value === "-" ||
  value === "—"
    ? "N/A"
    : value;

const SupplierWeeklyTable = ({ rows = [], dateInfo }) => {
 const pagination = true;
  const paginationPageSize = 250;
const paginationPageSizeSelector = [250, 500, 750, 1000];

  const publishedDate = formatDisplayValue(dateInfo?.published);
  const currentDate = formatDisplayValue(dateInfo?.current);
  const confirmationDate = formatDisplayValue(dateInfo?.confirmation);


  const columns = useMemo(
    () => [
      {
        field: "weekofGRDate",
        headerName: "Week of delivery date(GR)",
        minWidth: 160,
        comparator: (valueA, valueB) => compareDateValues(valueA, valueB),
        filterParams: {
          comparator: (valueA, valueB) => compareDateValues(valueA, valueB),
        },
      },
      {
        field: "totalSupplierForecast(Original)",
        headerName: "Supplier Forecast Published",
        flex: 1,
        minWidth: 190,
        headerComponent: HeaderWithInfo,
        headerComponentParams: {
          infoText: `Forecast Published Date: ${publishedDate}`,
          
        },
      },
     
      {
        field: "totalSupplierForecast(Current)",
        headerName: "Current SAP Forecast",
        flex: 1,
        minWidth: 160,
        headerComponent: HeaderWithInfo,
        headerComponentParams: {
          infoText: `Current SAP Forecast Date: ${currentDate}`,
          
        },
      },
     
     
      {
        field: "totalSupplierConfirmation",
        headerName: "Total Supplier Confirmation",
        flex: 1,
        minWidth: 190,
        headerComponent: HeaderWithInfo,
        headerComponentParams: {
          infoText: `Confirmation Date: ${confirmationDate}`,
          
        },
        valueFormatter: (params) => formatSupplierConfirmation(params.value),
      },
      {
        field: "supplierComment",
        headerName: "Supplier Comment",
        flex: 1,
        minWidth: 200,
        valueFormatter: (params) => formatDisplayValue(params.value),
      },
      { field: "delta(Cumulative)Current", headerName: "Delta(Cumulative) Current SAP Forecast", flex: 1, minWidth: 190 },
       {
        headerName: "PDT(Days)",
        field: "pdt",
        filter: true,
        width: 140,
        valueFormatter: (params) => formatDisplayValue(params.value),
      },
    ],
    [publishedDate, currentDate, confirmationDate]
  );

const tableData = useMemo(() => {
    return (rows || []).map((r, idx) => ({
      id: r.afcSequenceId ?? idx,

      "weekofGRDate": formatDisplayValue(r.weekStartDate),
        
          

      "totalSupplierForecast(Original)": r.originalForecast ?? 0,
      "totalSupplierForecast(Current)": r.sumOfForecast ?? r.originalForecast ?? 0,
      totalSupplierConfirmation:
        r.totalSupplierConfirmation ?? r.supplierQuantityConfirmation ?? null,
      "supplierComment": formatDisplayValue(r.supplierComment),
      "delta(Cumulative)Current": r.deltaCumulativeCurrent ?? 0,
      pdt: formatDisplayValue(r.pdt),
    }));
  }, [rows]);

  return (
    <Box sx={{ mt: 2 }}>
      <DataTable columns={columns} rows={tableData}
      height={400}
      paginationProp={pagination}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
            defaultColDef={{
    resizable: true,
    filter: 'agSetColumnFilter',
    filterParams: {
      excelMode: 'windows',
      suppressMiniFilter: false,
      buttons: ['apply', 'reset'],
    },
  }}
      />
    </Box>
  );
};

export default SupplierWeeklyTable;